module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dcRJ5"))).then(() => parcelRequire('2KbAe'));